import Toast from '../constants/constants';
import ApiCalls from '../classes/ApiCalls';
import store from '../state/store/Store';

export class UserRepository
{
    create()
    {
        backdrop.show('Creating user...Please wait!');
        let form = $('#create-user-form');
        let formData = new FormData();
        let userPicture = store.getState().fileUpload.data?.passportPictureBlobFile ?? null;
        formData.append('serial', form.serialize());
        formData.append('userPicture', userPicture);

        let extraAjaxOptions = {
            processData: false,
            contentType: false,
            async: false,
            cache: false,
        }

        let success = function(response){
            backdrop.hide();
            Toast.fire({
                icon: response.type,
                title: response.title
            });
            form.find('input, select, textarea').val('')
        }
        let errorMessage = 'Failed to create new user. Please check your connection and try again or contact your System Administrator';

        new ApiCalls(formData, form.attr('action'), success, errorMessage, extraAjaxOptions).dispatch()
    }
}
